import React, { useContext } from "react";
import { InlineMath } from "react-katex";
import { ThemeContext } from "../../context/ThemeContext";

export default function InclinedRoadDiagram({ length = 100, elevation = 34.2, angle = 20 }) {
  const { theme } = useContext(ThemeContext);
  const textColor = theme === "light" ? "#000000" : "#ffffff";

  // Stałe współrzędne bazowe trójkąta (kąt ok. 20°)
  const padding = 40;
  const startX = padding;
  const startY = 180;
  const hypotenuse = 400; // stała długość odcinka drogi
  const angleRad = (15 * Math.PI) / 180; // stały kąt
  const vertical = Math.sin(angleRad) * hypotenuse;
  const base = Math.cos(angleRad) * hypotenuse;
  const endX = startX + base;
  const endY = startY - vertical;

  return (
    <svg width={base + 2 * padding} height={240} style={{ display: "block", margin: "0 auto" }}>
      {/* Trójkąt drogi */}
      <polygon
        points={`${startX},${startY} ${endX},${startY} ${endX},${endY}`}
        fill={theme === "light" ? "#f9f9f9" : "#000000"}
        stroke={textColor}
        strokeWidth="2"
      />

      {/* Linia wysokości w kolorze pomarańczowym */}
      <line
        x1={endX}
        y1={startY}
        x2={endX}
        y2={endY}
        stroke="#ff8000"
        strokeWidth="3"
      />

      {/* Długość drogi (przeciwprostokątna) */}
      <foreignObject x={(startX + endX) / 2 - 20} y={(startY + endY) / 2 - 30} width="80" height="30">
        <div style={{ color: textColor }}>
          <InlineMath math={String(length)} />
        </div>
      </foreignObject>

      {/* Etykieta wysokości: "h" */}
      <foreignObject x={endX + 5} y={(startY + endY) / 2 - 15} width="80" height="30">
        <div style={{ color: textColor }}>
          <InlineMath math="h" />
        </div>
      </foreignObject>

      {/* Kąt w wierzchołku */}
      <foreignObject x={startX + 85} y={startY - 21} width="80" height="30">
        <div style={{ color: textColor, fontSize: "14px" }}>
          <InlineMath math={`${angle}^\\circ`} />
        </div>
      </foreignObject>
    </svg>
  );
}
